import React from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import { IVarietyListItem } from '../../../modules/API/Defaults/models/varietyList'
import SproutIcon from '../../icons/IconLib/SproutIcon'

interface Props {
    items: IVarietyListItem[]
    value: IVarietyListItem | null
    onSelect: (variety: IVarietyListItem | null) => void
    placeholder?: string
    disabled?: boolean
    readOnly?: boolean
    className?: string
}

const VarietySelector: React.FC<Props> = ({
    items,
    value,
    onSelect,
    placeholder = 'בחר זן',
    disabled,
    readOnly,
    className,
}) => (
    <SearchableSelect<IVarietyListItem>
        items={items}
        value={value}
        onSelect={onSelect}
        getKey={(v) => String(v.VarietyID)}
        getLabel={(v) => (v.VarietyDesc ?? '').trim()}
        getSearchText={(v) => `${v.VarietyDesc ?? ''} ${v.VarietyDescEng ?? ''}`}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={<SproutIcon />}
        className={className}
        emptyLabel='אין זנים מתאימים'
    />
)

export default VarietySelector
